<template>
    <div>
        <breadcrumb :routerList="[{to:'/bscClueOnlineMatrixList',title:'线上矩阵列表'},{title:'新增线上矩阵'}]"/>
        <div class="h-content"  :class="{'h-view-mode': isView}">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail14">
                                        <el-form :model="add" label-position="left" ref="addForm" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="托盘商公司名称" prop="companyName" class="h-elformWrap-2" v-if="add.taskType!=0 && add.taskType!=4">
                                                <el-input v-model="add.companyName" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="运营人员电话" prop="operatorTelephone" class="h-elformWrap-2" v-if="add.taskType!=0 && add.taskType!=4">
                                                <el-select v-model="add.operatorTelephone" placeholder="请选择" clearable style="width:100%;" @change="handleOperatorChange">
                                                    <el-option v-for="(item, idx) in operatorPhoneList" :key="'o'+idx" :label="item.ownerName + ' - ' + item.phone" :value="item.phone"></el-option>
                                                </el-select>
                                            </el-form-item>


                                            <el-form-item label="电商平台名称" prop="platformName" class="h-elformWrap-2">
                                                <brselect  :dictNameAsValues=true category="platform_name" :v="add.platformName" v-model="add.platformName"></brselect>
                                            </el-form-item>
                                            <el-form-item label="订单类型" prop="orderType" class="h-elformWrap-2">
                                                <el-select v-model="add.orderType" placeholder="请选择" clearable >
                                                    <el-option label="咨询订单" value="咨询订单"></el-option>
                                                    <el-option label="正常订单" value="正常订单"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="订单所在省份" prop="orderProvince" class="h-elformWrap-2">
                                                <el-select v-model="add.orderProvince" filterable clearable @change="handleProvinceChange($event)" placeholder="请选择" style="width:100%;">
                                                    <el-option v-for="item in shenglist" :key="item.name" :label="item.name" :value="item.name"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="订单所在城市" prop="orderCity" class="h-elformWrap-2">
                                                <el-select v-model="add.orderCity" filterable clearable placeholder="请先选择城市" style="width:100%;" :disabled="!add.orderProvince">
                                                    <el-option v-for="item in cityList" :key="item.name" :label="item.name" :value="item.name"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="订单详细地址" prop="address" class="h-elformWrap-2">
                                                <el-input v-model="add.address" placeholder="请输入详细地址" clearable></el-input>
                                            </el-form-item>

                                            <el-form-item label="用户单位" prop="userUnitName" class="h-elformWrap-2 h-elformWrap-userUnit">
                                                <el-select v-model="add.userUnitName" remote filterable :filter-method="showFormList"  :v="add.userUnitName" clearable placeholder="请输入" :remote-method="showFormList">
                                                    <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="h-elformWrap-m"  v-if="!isView">
                                                <i class="el-icon-circle-plus" @click="createAddress"></i>
                                            </el-form-item>


                                            <el-form-item label="用户电话号码" prop="userPhone" class="h-elformWrap-2">
                                                <el-input v-model="add.userPhone" placeholder="用户电话号码" clearable></el-input>
                                            </el-form-item>

                                            <el-form-item label="备注" prop="remark" class="h-elformWrap-2">
                                                <el-input v-model="add.remark" placeholder="备注" clearable></el-input>
                                            </el-form-item>

                                            <template v-if="isView && add.companyCode == _user.usercode">
                                                <el-form-item v-for="(owner, idx) in add.agentOwnerList" :key="'owner'+idx" :label="'经销商联系人' + (add.agentOwnerList.length > 1 ? (idx + 1) : '')" class="h-elformWrap-2">
                                                    <el-input :value="owner.ownerName + ' - ' + owner.phone" readonly></el-input>
                                                </el-form-item>
                                            </template>

                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 付款凭证（查看模式） -->
                    <div v-if="isView" class="h-rowBox ljjtablepaddings12" style="margin-top:30px;">
                        <div class="h-rowCon" >
                            <div class="h-pieceIn2" >
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>付款凭证</h1>
                                </div>
                            </div>
                            <div class="h-pieceCon2">
                                <div class="h-formLine weekplandetail14">
                                    <brupload
                                        :refid="add.id"
                                        reftype="线上矩阵-付款凭证"
                                        :uploadflag="false"
                                        :delflag="false"
                                        :showtime="true">
                                    </brupload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 回传单号（查看模式） -->
                    <div v-if="isView && add.wuliufangshi" class="h-rowBox ljjtablepaddings12" style="margin-top:30px;">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>回传单号</h1>
                                </div>
                            </div>
                            <div class="h-pieceCon2">
                                <div class="h-formLine weekplandetail14">
                                <el-form :model="add" label-position="left" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="物流类型" class="h-elformWrap-2">
                                        <el-input :value="add.wuliufangshi" readonly></el-input>
                                    </el-form-item>
                                    <template v-if="add.wuliufangshi == '快递物流'">
                                        <el-form-item label="快递公司" class="h-elformWrap-2">
                                            <el-input :value="add.kuaidiCompany" readonly></el-input>
                                        </el-form-item>
                                        <el-form-item label="快递单号" class="h-elformWrap-2">
                                            <el-input :value="add.kuaidiNumber" readonly></el-input>
                                        </el-form-item>
                                    </template>
                                    <template v-if="add.wuliufangshi == '自己运输' || add.wuliufangshi == '网点配送'">
                                        <el-form-item label="送货车牌号" class="h-elformWrap-2">
                                            <el-input :value="add.carNumber" readonly></el-input>
                                        </el-form-item>
                                        <el-form-item label="司机姓名" class="h-elformWrap-2">
                                            <el-input :value="add.driverName" readonly></el-input>
                                        </el-form-item>
                                        <el-form-item label="司机电话" class="h-elformWrap-2">
                                            <el-input :value="add.driverPhone" readonly></el-input>
                                        </el-form-item>
                                        <el-form-item label="驾驶证编号" class="h-elformWrap-2">
                                            <el-input :value="add.driverLicenseNumber" readonly></el-input>
                                        </el-form-item>
                                    </template>
                                </el-form>
                            </div>
                            </div>
                        </div>
                    </div>


                    <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>型号明细</h1>
                                </div>
                            </div>
                            <el-table
                                ref="detailTable"
                                :data="add.detailList"
                                stripe
                                style="width: 100%"
                                :border="true">
                                <el-table-column type="index" width="50" label="#"></el-table-column>

                                <el-table-column prop="productModel" label="产品型号">
                                    <template slot-scope="scope">
                                        <el-select :disabled="isView" class="h-tableInput" v-model="scope.row.productModel" filterable remote :remote-method="selectAllwuliao" :filter-method="selectAllwuliao" placeholder="请输入型号搜索" clearable default-first-option style="width:100%;"
                                                   @change="handleModelSelect(scope.row, $event)">
                                            <el-option v-for="(item, idx) in wuliaoList" :key="'m'+idx" :label="item.promodel + ' - ' + item.prodcode" :value="item.promodel"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="productCode" label="产品编码">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.productCode" placeholder="选择型号后自动填充" disabled></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="oneLevelName" label="产品大类">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.oneLevelName" placeholder="选择型号后自动填充" disabled></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="twoLevelName" label="二级分类">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.twoLevelName" placeholder="选择型号后自动填充" disabled></el-input>
                                    </template>
                                </el-table-column>


                                <el-table-column prop="productNum" label="数量" width="120">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" type="number" v-model="scope.row.productNum"  controls-position="right"></el-input>
                                    </template>
                                </el-table-column>
                                <!-- 只有托盘商自己能看金额 -->
                                <el-table-column  v-if=" (add.companyCode == _user.usercode)" prop="amount" label="金额（售卖单价）" width="180">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"  v-model="scope.row.amount"  controls-position="right" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" fixed="right" width="180">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" class="h-tableLink h-btn" style="color:#f56c6c;" @click="delDetail(scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="h-tableAdd" @click="addDetail">
                                <a>添加一行</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>



            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiao">返回</el-button>
                <el-button  v-if="!isView" class="h-btn h-bBtn h-bgblueQ2" @click="submitForm(1)">确认提交</el-button>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="institutionalX" class="h-dialog2">
            <companyName ref="companyName" :titleName="titleDig" :add1="addAddress" :stVal="stVal" @getChildValue="closeDialog"></companyName>
        </el-dialog>

    </div>
</template>
<script>
import ss from '../../../api/SystemService'
import BscClueOnlineMatrix from '@/api/guanhuai/onlineMatrix/BscClueOnlineMatrix'
import companyName from "@/components/basic/companyName.vue";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
    components: {companyName},
    data() {
        return {
            titleDig: '',
            institutionalX: false,
            isView: false,
            stVal: null,
            addAddress: {
                id: '',
                deptName: '',
                deptType: '',
                leader: '',
                phone: '',
                email: '',
                status: '',
                countryId: '',
                country: '',
                provinceId: '',
                province: '',
                cityId: '',
                city: '',
                areaId: '',
                landmark: '',
                area: '',
                shengobj: '',
                shiobj: '',
                quobj: '',
                selectId: '',
                address: '',
                subFlag: '',
                deptSourceChannel: '',
                longitude: '',
                latitude: '',
                parentCode: '',
                schoolTypeName: '',
            },

            add: {
                companyName: '',
                companyCode: '',
                operator: '',
                operatorTelephone: '',
                platformName: '',
                orderType: '',
                bigArea: '',
                orderProvince: '',
                orderCity: '',
                address: '',
                userUnitName: '',
                userPhone: '',
                remark: '',
                // 回传单号字段
                wuliufangshi: '',
                kuaidiCompany: '',
                kuaidiCompanyCode: '',
                kuaidiNumber: '',
                carNumber: '',
                driverName: '',
                driverPhone: '',
                driverLicenseNumber: '',
                detailList: [
                    {oneLevelName: '',oneLevelCode: '', twoLevelName: '',twoLevelCode: '', productCode: '', productModel: '', productNum: 0, amount: 0 }
                ],
                agentOwnerList: [],
            },

            //客户地址信息
            addrList: [],
            //物料列表
            wuliaoList: [],

            companyList: [],
            operatorPhoneList: [],
            shenglist: [],
            cityList: [],
            rules: {
                companyName: [{ required: true, message: '请选择托盘商公司名称', trigger: 'change' }],
                operatorTelephone: [{ required: true, message: '请选择运营人员电话', trigger: 'change' }],
                platformName: [{ required: true, message: '请选择电商平台名称', trigger: 'change' }],
                orderType: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
                orderProvince: [{ required: true, message: '请选择订单所在省份', trigger: 'change' }],
                orderCity: [{ required: true, message: '请选择订单所在城市', trigger: 'change' }],
                address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
                userUnitName: [{ required: true, message: '请输入用户单位', trigger: 'blur' }],
                // 新增
                userPhone: [
                    { pattern: /^[\d\-()（） ]{7,25}$/, message: '电话号码只能包含数字、-、括号、空格，不能包含汉字和英文字母', trigger: 'blur' }
                ],
            },
        }
    },
    created() {
        // 是否为查看模式
        this.isView = this.$route.query.viewMode == 1;
        if (this.isView && this.$route.query.id) {
            this.loadDetail(this.$route.query.id);
        } else {
            this.loadArea();
            this.selectOperatorPhone();
        }

    },
    methods: {
        loadDetail(id) {
            BscClueOnlineMatrix.selectById(id).then(rd => {

                Object.assign(this.add, rd.obj );

            })
        },
        //加载省
        loadArea() {
            let proSelect = { pcode: 0, level: 1 }
            ss.Dictservice.arealist(proSelect).then(rd => {
                this.shenglist = rd;
                console.log("shenglist",this.shenglist)
            })
        },

        //获取收货单位
        showFormList (value) {
            ss.OrderMainService.getCompanyInfo(value).then(rd => {
                this.addrList = rd;
                if (value == "个人") {
                    const exists = this.addrList.some(item => item.deptName == "个人");
                    if (!exists) {
                        this.addrList.push({ id: '个人', deptName: '个人' });
                    }
                }
            })
        },
        //新增收货单位
        createAddress () {
            this.titleDig = "新建用户单位"
            this.institutionalX = true;
        },
        closeDialog () {
            this.institutionalX = false;
        },

        //查询物料信息
        selectAllwuliao (value) {
            let proSelect = { prodcodeLike: value, fromtype:'s' }
            ss.BscClueOnlineMatrix.selectAllwuliao(proSelect).then(rd => {
                this.wuliaoList = rd.obj;
            })
        },

        //查询托盘商联系方式
        selectOperatorPhone() {

            var userCode = this._user.usercode

            ss.BscClueOnlineMatrix.selectPalletDealer(userCode).then(rd => {
                if (!rd.obj || rd.obj.length === 0) {
                    this.$msg.msge('当前登录人员未维护线上专营商合同或运营人信息，不能提交数据');
                    return;
                }
                this.add.companyCode = this._user.usercode;
                this.add.companyName = this._user.username;

                this.operatorPhoneList = rd.obj;
            })
        },

        handleModelSelect(row, val) {
            if (!val) {
                this.$set(row, 'productCode', '');
                return;
            }
            const matched = this.wuliaoList.find(item => item.promodel === val);
            if (matched) {
                this.$set(row, 'oneLevelCode', matched.oneLid);
                this.$set(row, 'oneLevelName', matched.prodseries);
                this.$set(row, 'twoLevelCode', matched.fourcode ? matched.fourcode.substring(0, 6) : matched.oneLid);
                this.$set(row, 'twoLevelName', matched.procategory);
                this.$set(row, 'productCode', matched.prodcode);
                this.$set(row, 'lianqun', matched.lianqun);
            }
        },
        handleOperatorChange(val) {
            if (!val) {
                this.add.operator = '';
                return;
            }
            const matched = this.operatorPhoneList.find(item => item.phone === val);
            if (matched) {
                this.add.operator = matched.ownerName;
            }
        },


        handleProvinceChange(val) {
            this.add.orderCity = '';
            this.cityList = [];
            if (val) {
                const province = _.find(this.shenglist, { name: val });
                if (province) {
                    ss.Dictservice.getCity({ code: province.code }).then(rd => {
                        this.cityList = rd.zlist || [];
                    });
                }
            }
        },
        addDetail() {
            this.add.detailList.push({ oneLevelName: '',oneLevelCode: '', twoLevelName: '',twoLevelCode: '',productCode: '', productModel: '', productNum: 0, amount: 0 });
        },
        delDetail(index) {
            this.$confirm('确认删除该行？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                if (this.add.detailList.length > 1) {
                    this.add.detailList.splice(index, 1);
                } else {
                    this.$message.warning('至少保留一行');
                }
            }).catch(() => {});
        },
        submitForm(flag) {
            this.$refs['addForm'].validate((valid) => {
                if (!valid) {
                    this.$msg.msge("请完善信息后再提交！");
                    return false;
                }
                for (let i = 0; i < this.add.detailList.length; i++) {
                    const row = this.add.detailList[i];
                    if (!row.productModel || row.productModel.trim() === '') {
                        this.$msg.msge('第' + (i + 1) + '行型号不能为空');
                        return;
                    }
                    if (!row.productNum || row.productNum <= 0) {
                        this.$msg.msge('第' + (i + 1) + '行数量必须大于0');
                        return;
                    }
                    if (row.amount === '' || row.amount === null || row.amount === undefined) {
                        this.$msg.msge('第' + (i + 1) + '行金额不能为空');
                        return;
                    }
                    if (Number(row.amount) < 0) {
                        this.$msg.msge('第' + (i + 1) + '行金额不能为负数');
                        return;
                    }

                }
                const params = Object.assign({}, this.add);
                console.log("params",params)
                ss.BscClueOnlineMatrix.saveOrUpdate(params).then(rd => {
                    this.$msg.msgs(rd.msg);
                    if (flag === 1) {
                        this.$router.go(-1);
                    }
                });
            });
        },
        quxiao() {
            this.$router.go(-1);
        },
    },
}
</script>
<style >
    .weekplandetail14 .h-formbLine .el-form-item__label {
        width: 35%;
        text-align: left;
        padding-left: 40px;
        position: relative;
    }



    .weekplandetail14 .h-formbLine .el-form-item.is-required .el-form-item__label::before {
        position: absolute;
        left: 26px;
    }

    .weekplandetail14 .h-formbLine .el-form-item__content {
        width: 65%;
    }

    .weekplandetail14 .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }
    .weekplandetail14 .h-formbLine .h-elformWrap-userUnit {
        width: calc(50% - 0.4rem);
    }

    .weekplandetail14 .h-formbLine .h-elformWrap-m {
        width: 0.4rem;
        margin-right: 0;
        margin-bottom: 0.38rem;
    }

    .weekplandetail14 .h-formbLine .h-elformWrap-m .el-icon-circle-plus {
        font-size: 0.22rem;
        color: #0e75e9;
        cursor: pointer;
        line-height: 0.28rem;
    }


    .ljjtablepaddings12 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings12 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }

    .ljj_selectdisblednone .el-input.is-disabled .el-input__inner{
        border-color: transparent;
    }
    .ljj_selectdisblednone.el-select .el-input.is-disabled .el-input__inner:hover{
        border-color: transparent;
    }
    .ljj_selectdisblednone .el-input__suffix{
        display: none;
    }

    .h-view-mode .el-input__inner,
    .h-view-mode .el-textarea__inner {
        background-color: #f5f7fa;
        cursor: not-allowed;
        pointer-events: none;
    }
    .h-view-mode .el-select .el-input__inner {
        pointer-events: none;
    }
    .h-view-mode .h-tableAdd {
        display: none;
    }
    .h-view-mode .h-tableLink {
        display: none;
    }
</style>
